export default {
  v: '5.9.0',
  fr: 24,
  ip: 0,
  op: 96,
  w: 412,
  h: 110,
  nm: 'logo animation web',
  ddd: 0,
  assets: [],
  fonts: {
    list: [
      {
        fName: 'Geist-SemiBold',
        fFamily: 'Geist',
        fStyle: 'SemiBold',
        ascent: 70.9991455078125
      }
    ]
  },
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'star',
      parent: 2,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.32], y: [1.27] },
              o: { x: [0.17], y: [0.89] },
              t: 49,
              s: [55]
            },
            { t: 60, s: [110] }
          ],
          ix: 10
        },
        p: { a: 0, k: [-0.378, -0.028, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ty: 'sr',
              sy: 1,
              d: 1,
              pt: { a: 0, k: 5, ix: 3 },
              p: { a: 0, k: [0, 0], ix: 4 },
              r: { a: 0, k: 0, ix: 5 },
              ir: { a: 0, k: 8.231, ix: 6 },
              is: { a: 0, k: 0, ix: 8 },
              or: { a: 0, k: 21.547, ix: 7 },
              os: { a: 0, k: 0, ix: 9 },
              ix: 1,
              nm: 'Polystar Path 1',
              mn: 'ADBE Vector Shape - Star',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform'
            }
          ],
          nm: 'Star 29',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 49,
      op: 649,
      st: 49,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'bubble',
      tt: 2,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.74 },
              o: { x: 0.52 },
              t: 72,
              s: [4.167, 107, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 96, s: [4.167, -3, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [-48, 48, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.32, 0.32, 0.32], y: [1.27, 1.27, 0] },
              o: { x: [0.17, 0.17, 0.17], y: [0.89, 0.89, 0] },
              t: 49,
              s: [0, 0, 100]
            },
            {
              i: { x: [0.32, 0.32, 0.32], y: [1, 1, 1] },
              o: { x: [0.17, 0.17, 0.17], y: [0, 0, 0] },
              t: 60,
              s: [100, 100, 100]
            },
            { t: 72, s: [100, 100, 100] }
          ],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-26.51, 0],
                    [0, -26.51],
                    [26.51, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  o: [
                    [26.51, 0],
                    [0, 26.51],
                    [0, 0],
                    [0, 0],
                    [0, -26.51]
                  ],
                  v: [
                    [0, -48],
                    [48, 0],
                    [0, 48],
                    [-48, 48],
                    [-48, 0]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: 'Transform'
            }
          ],
          nm: 'Rectangle 91',
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 49,
      op: 649,
      st: 49,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 5,
      nm: 'd',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.36, y: 1 },
              o: { x: 0.22, y: 0.792 },
              t: 5,
              s: [372.26, 157.328, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.78, y: 0.167 },
              o: { x: 0.22, y: 0 },
              t: 24,
              s: [372.26, 62.328, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 44, s: [372.26, -52.672, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [6.272, -4.622, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [96, 101.657623291016],
                ps: [-48, -50.8288116455078],
                s: 128,
                f: 'Geist-SemiBold',
                t: 'd',
                ca: 0,
                j: 1,
                tr: -50,
                lh: 115.199996948242,
                ls: 0,
                fc: [0, 0, 0]
              },
              t: 0
            }
          ]
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: []
      },
      ip: 5,
      op: 605,
      st: 5,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 5,
      nm: 'n',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.36, y: 1 },
              o: { x: 0.22, y: 0.792 },
              t: 4,
              s: [303.59, 167.056, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.36, y: 0.36 },
              o: { x: 0.22, y: 0.22 },
              t: 23,
              s: [303.59, 72.056, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.78, y: 0.125 },
              o: { x: 0.64, y: 0 },
              t: 24,
              s: [303.59, 72.056, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 45, s: [303.59, -42.944, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [9.536, 7.935, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [96, 96],
                ps: [-48, -48],
                s: 128,
                f: 'Geist-SemiBold',
                t: 'n',
                ca: 0,
                j: 1,
                tr: -50,
                lh: 115.199996948242,
                ls: 0,
                fc: [0, 0, 0]
              },
              t: 0
            }
          ]
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: []
      },
      ip: 4,
      op: 604,
      st: 4,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 5,
      nm: 'e',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.36, y: 1 },
              o: { x: 0.22, y: 0.792 },
              t: 3,
              s: [235.135, 167.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.36, y: 0.36 },
              o: { x: 0.22, y: 0.22 },
              t: 22,
              s: [235.135, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.78, y: 0.083 },
              o: { x: 0.64, y: 0 },
              t: 24,
              s: [235.135, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 46, s: [235.135, -42.176, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [10.112, 8.703, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [96, 96],
                ps: [-48, -48],
                s: 128,
                f: 'Geist-SemiBold',
                t: 'e',
                ca: 0,
                j: 1,
                tr: -50,
                lh: 115.199996948242,
                ls: 0,
                fc: [0, 0, 0]
              },
              t: 0
            }
          ]
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: []
      },
      ip: 3,
      op: 603,
      st: 3,
      bm: 0
    },
    {
      ddd: 0,
      ind: 6,
      ty: 5,
      nm: 'c',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.36, y: 1 },
              o: { x: 0.22, y: 0.792 },
              t: 2,
              s: [168.51, 167.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.36, y: 0.36 },
              o: { x: 0.22, y: 0.22 },
              t: 21,
              s: [168.51, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.78, y: 0.042 },
              o: { x: 0.64, y: 0 },
              t: 24,
              s: [168.51, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 47, s: [168.51, -42.176, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [11.52, 8.703, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [96, 96],
                ps: [-48, -48],
                s: 128,
                f: 'Geist-SemiBold',
                t: 'c',
                ca: 0,
                j: 1,
                tr: -50,
                lh: 115.199996948242,
                ls: 0,
                fc: [0, 0, 0]
              },
              t: 0
            }
          ]
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: []
      },
      ip: 2,
      op: 602,
      st: 2,
      bm: 0
    },
    {
      ddd: 0,
      ind: 7,
      ty: 5,
      nm: 's',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.36, y: 1 },
              o: { x: 0.22, y: 0.792 },
              t: 1,
              s: [103.395, 167.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.36, y: 0.36 },
              o: { x: 0.22, y: 0.22 },
              t: 20,
              s: [103.395, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.78, y: 0 },
              o: { x: 0.64, y: 0 },
              t: 24,
              s: [103.395, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 48, s: [103.395, -42.176, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [12.352, 8.703, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [96, 96],
                ps: [-48, -48],
                s: 128,
                f: 'Geist-SemiBold',
                t: 's',
                ca: 0,
                j: 1,
                tr: -50,
                lh: 115.199996948242,
                ls: 0,
                fc: [0, 0, 0]
              },
              t: 0
            }
          ]
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: []
      },
      ip: 1,
      op: 601,
      st: 1,
      bm: 0
    },
    {
      ddd: 0,
      ind: 8,
      ty: 5,
      nm: 'a',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.36, y: 1 },
              o: { x: 0.22, y: 0.792 },
              t: 0,
              s: [39.406, 167.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.36, y: 0.36 },
              o: { x: 0.22, y: 0.22 },
              t: 19,
              s: [39.406, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.789, y: 0 },
              o: { x: 0.64, y: 0 },
              t: 24,
              s: [39.406, 72.824, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            { t: 49, s: [39.406, -42.176, 0] }
          ],
          ix: 2,
          l: 2
        },
        a: { a: 0, k: [12.416, 8.703, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                sz: [96, 96],
                ps: [-48, -48],
                s: 128,
                f: 'Geist-SemiBold',
                t: 'a',
                ca: 0,
                j: 1,
                tr: -50,
                lh: 115.199996948242,
                ls: 0,
                fc: [0, 0, 0]
              },
              t: 0
            }
          ]
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: []
      },
      ip: 0,
      op: 600,
      st: 0,
      bm: 0
    }
  ],
  markers: [],
  chars: [
    {
      ch: 'a',
      size: 128,
      style: 'SemiBold',
      w: 57.8,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.667, 1],
                      [-1.767, 1.834],
                      [-0.534, 2.334],
                      [0, 0],
                      [-0.934, -1.766],
                      [-1.734, -0.7],
                      [-2.2, 0],
                      [-0.9, 0.066],
                      [-0.4, 0.133],
                      [0, 0],
                      [0, 0],
                      [0.5, 0.534],
                      [0, 1.4],
                      [0, 0],
                      [3.9, 3.834],
                      [7.6, 0],
                      [4.133, -3.033],
                      [1.066, -5.666],
                      [0, 0],
                      [-1.767, 1.434],
                      [-3.067, 0],
                      [-1.734, -1.9],
                      [0, -3.8],
                      [0, 0],
                      [2.866, -2.6],
                      [0, -4.6],
                      [-3.4, -2.566],
                      [-5.6, 0]
                    ],
                    o: [
                      [2.666, -1],
                      [1.766, -1.833],
                      [0, 0],
                      [0, 3.067],
                      [0.933, 1.767],
                      [1.733, 0.7],
                      [0.933, 0],
                      [0.9, -0.067],
                      [0, 0],
                      [0, 0],
                      [-1, 0],
                      [-0.5, -0.533],
                      [0, 0],
                      [0, -7.133],
                      [-3.9, -3.833],
                      [-6.6, 0],
                      [-4.134, 3.034],
                      [0, 0],
                      [0.666, -2.666],
                      [1.766, -1.433],
                      [3.4, 0],
                      [1.733, 1.9],
                      [0, 0],
                      [-5.867, 1.134],
                      [-2.867, 2.6],
                      [0, 4.6],
                      [3.4, 2.567],
                      [3.333, 0]
                    ],
                    v: [
                      [31.5, -0.3],
                      [38.15, -4.55],
                      [41.6, -10.8],
                      [40.5, -11.6],
                      [41.9, -4.35],
                      [45.9, -0.65],
                      [51.8, 0.4],
                      [54.55, 0.3],
                      [56.5, 0],
                      [56.5, -9.3],
                      [54.8, -9.3],
                      [52.55, -10.1],
                      [51.8, -13],
                      [51.8, -32.4],
                      [45.95, -48.85],
                      [28.7, -54.6],
                      [12.6, -50.05],
                      [4.8, -37],
                      [17.8, -36.4],
                      [21.45, -42.55],
                      [28.7, -44.7],
                      [36.4, -41.85],
                      [39, -33.3],
                      [21.3, -29.8],
                      [8.2, -24.2],
                      [3.9, -13.4],
                      [9, -2.65],
                      [22.5, 1.2]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'a',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              },
              {
                ind: 1,
                ty: 'sh',
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.366, 1.134],
                      [0, 2.067],
                      [-1.234, 1.167],
                      [-2.867, 0.6],
                      [0, 0],
                      [0, 0],
                      [1.133, -2],
                      [2.066, -1.133],
                      [2.866, 0]
                    ],
                    o: [
                      [-1.367, -1.133],
                      [0, -1.866],
                      [1.233, -1.166],
                      [0, 0],
                      [0, 0],
                      [0, 2.734],
                      [-1.134, 2],
                      [-2.067, 1.134],
                      [-2.534, 0]
                    ],
                    v: [
                      [19.25, -9.8],
                      [17.2, -14.6],
                      [19.05, -19.15],
                      [25.2, -21.8],
                      [39, -24.6],
                      [39, -21.6],
                      [37.3, -14.5],
                      [32.5, -9.8],
                      [25.1, -8.1]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'a',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              }
            ],
            nm: 'a',
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }
        ]
      },
      fFamily: 'Geist'
    },
    {
      ch: 's',
      size: 128,
      style: 'SemiBold',
      w: 54.6,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.434, 1.233],
                      [-1.9, 2.4],
                      [0, 3.4],
                      [1.366, 2.1],
                      [3.233, 1.367],
                      [5.6, 0.867],
                      [1.6, 0.567],
                      [0.7, 0.934],
                      [0, 1.4],
                      [-1.534, 1.2],
                      [-3, 0],
                      [-1.467, -0.7],
                      [-0.867, -1.333],
                      [-0.334, -1.8],
                      [0, 0],
                      [1.833, 2.7],
                      [3.266, 1.567],
                      [4.8, 0],
                      [3.833, -3.1],
                      [0, -5],
                      [-1.3, -2.066],
                      [-3.134, -1.366],
                      [-5.467, -0.933],
                      [-1.667, -0.6],
                      [-0.6, -0.8],
                      [0, -1.2],
                      [1.7, -0.966],
                      [3, 0],
                      [1.866, 1.534],
                      [0.466, 2.8],
                      [0, 0],
                      [-1.934, -2.733],
                      [-3.567, -1.533],
                      [-5.267, 0]
                    ],
                    o: [
                      [3.433, -1.233],
                      [1.9, -2.4],
                      [0, -2.933],
                      [-1.367, -2.1],
                      [-3.234, -1.366],
                      [-2.667, -0.466],
                      [-1.6, -0.566],
                      [-0.7, -0.933],
                      [0, -2],
                      [1.533, -1.2],
                      [2, 0],
                      [1.466, 0.7],
                      [0.866, 1.334],
                      [0, 0],
                      [-0.467, -3.466],
                      [-1.834, -2.7],
                      [-3.267, -1.566],
                      [-7.4, 0],
                      [-3.834, 3.1],
                      [0, 3.067],
                      [1.3, 2.067],
                      [3.133, 1.367],
                      [3.266, 0.6],
                      [1.666, 0.6],
                      [0.6, 0.8],
                      [0, 2.067],
                      [-1.7, 0.967],
                      [-3.667, 0],
                      [-1.867, -1.533],
                      [0, 0],
                      [0.266, 3.467],
                      [1.933, 2.734],
                      [3.566, 1.533],
                      [4.6, 0]
                    ],
                    v: [
                      [40.75, -0.65],
                      [48.75, -6.1],
                      [51.6, -14.8],
                      [49.55, -22.35],
                      [42.65, -27.55],
                      [29.4, -30.9],
                      [23, -32.45],
                      [19.55, -34.7],
                      [18.5, -38.2],
                      [20.8, -43],
                      [27.6, -44.8],
                      [32.8, -43.75],
                      [36.3, -40.7],
                      [38.1, -36],
                      [51, -36.6],
                      [47.55, -45.85],
                      [39.9, -52.25],
                      [27.8, -54.6],
                      [10.95, -49.95],
                      [5.2, -37.8],
                      [7.15, -30.1],
                      [13.8, -24.95],
                      [26.7, -21.5],
                      [34.1, -19.7],
                      [37.5, -17.6],
                      [38.4, -14.6],
                      [35.85, -10.05],
                      [28.8, -8.6],
                      [20.5, -10.9],
                      [17, -17.4],
                      [3.9, -16.8],
                      [7.2, -7.5],
                      [15.45, -1.1],
                      [28.7, 1.2]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 's',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              }
            ],
            nm: 's',
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }
        ]
      },
      fFamily: 'Geist'
    },
    {
      ch: 'c',
      size: 128,
      style: 'SemiBold',
      w: 57,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.534, 1.7],
                      [-2.2, 3.134],
                      [-0.534, 4.267],
                      [0, 0],
                      [2.1, -1.8],
                      [3.133, 0],
                      [2.266, 3.067],
                      [0, 5.534],
                      [-2.267, 3.1],
                      [-4.134, 0],
                      [-2.1, -1.766],
                      [-0.534, -3.4],
                      [0, 0],
                      [2.233, 2.967],
                      [3.533, 1.6],
                      [4.533, 0],
                      [3.933, -2.333],
                      [2.166, -4.166],
                      [0, -5.6],
                      [-2.167, -4.2],
                      [-3.934, -2.3],
                      [-5.334, 0]
                    ],
                    o: [
                      [3.533, -1.7],
                      [2.2, -3.133],
                      [0, 0],
                      [-0.467, 3.8],
                      [-2.1, 1.8],
                      [-4.134, 0],
                      [-2.267, -3.066],
                      [0, -5.466],
                      [2.266, -3.1],
                      [3.066, 0],
                      [2.1, 1.767],
                      [0, 0],
                      [-0.534, -4.266],
                      [-2.234, -2.966],
                      [-3.534, -1.6],
                      [-5.334, 0],
                      [-3.934, 2.334],
                      [-2.167, 4.167],
                      [0, 5.6],
                      [2.166, 4.2],
                      [3.933, 2.3],
                      [4.6, 0]
                    ],
                    v: [
                      [42.4, -1.35],
                      [51, -8.6],
                      [55.1, -19.7],
                      [41.9, -20.3],
                      [38.05, -11.9],
                      [30.2, -9.2],
                      [20.6, -13.8],
                      [17.2, -26.7],
                      [20.6, -39.55],
                      [30.2, -44.2],
                      [37.95, -41.55],
                      [41.9, -33.8],
                      [55.1, -34.5],
                      [50.95, -45.35],
                      [42.3, -52.2],
                      [30.2, -54.6],
                      [16.3, -51.1],
                      [7.15, -41.35],
                      [3.9, -26.7],
                      [7.15, -12],
                      [16.3, -2.25],
                      [30.2, 1.2]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'c',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              }
            ],
            nm: 'c',
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }
        ]
      },
      fFamily: 'Geist'
    },
    {
      ch: 'e',
      size: 128,
      style: 'SemiBold',
      w: 58.1,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-4.3, 3],
                      [-1.467, 5.2],
                      [0, 0],
                      [1.9, -1.3],
                      [2.866, 0],
                      [2.3, 2.367],
                      [0.266, 4.667],
                      [0, 0],
                      [0, 0],
                      [2.066, 4.267],
                      [3.833, 2.267],
                      [5.066, 0],
                      [3.9, -2.333],
                      [2.133, -4.166],
                      [0, -5.6],
                      [-2.134, -4.2],
                      [-3.934, -2.3],
                      [-5.334, 0]
                    ],
                    o: [
                      [4.3, -3],
                      [0, 0],
                      [-0.734, 2.334],
                      [-1.9, 1.3],
                      [-3.8, 0],
                      [-2.3, -2.366],
                      [0, 0],
                      [0, 0],
                      [0, -6],
                      [-2.067, -4.266],
                      [-3.834, -2.266],
                      [-5.2, 0],
                      [-3.9, 2.334],
                      [-2.134, 4.167],
                      [0, 5.6],
                      [2.133, 4.2],
                      [3.933, 2.3],
                      [6.133, 0]
                    ],
                    v: [
                      [45.75, -3.3],
                      [54.4, -15.6],
                      [41.3, -16.4],
                      [37.35, -10.95],
                      [30.2, -9],
                      [21.05, -12.55],
                      [17.2, -23.1],
                      [55.1, -23.1],
                      [55.1, -26],
                      [52, -41.4],
                      [43.15, -51.2],
                      [29.8, -54.6],
                      [16.15, -51.1],
                      [7.1, -41.35],
                      [3.9, -26.7],
                      [7.1, -12],
                      [16.2, -2.25],
                      [30.1, 1.2]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'e',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              },
              {
                ind: 1,
                ty: 'sh',
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.234, 2.2],
                      [-3.4, 0],
                      [-2.2, -2.1],
                      [-0.267, -4.333],
                      [0, 0]
                    ],
                    o: [
                      [2.233, -2.2],
                      [3.4, 0],
                      [2.2, 2.1],
                      [0, 0],
                      [0.533, -4.133]
                    ],
                    v: [
                      [21.35, -41.2],
                      [29.8, -44.5],
                      [38.2, -41.35],
                      [41.9, -31.7],
                      [17.2, -31.7]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'e',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              }
            ],
            nm: 'e',
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }
        ]
      },
      fFamily: 'Geist'
    },
    {
      ch: 'n',
      size: 128,
      style: 'SemiBold',
      w: 58.4,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-2.034, 2.4],
                      [-3.4, 0],
                      [-1.367, -1.1],
                      [-0.6, -2.066],
                      [0, -3],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.4, 3.034],
                      [2.7, 1.734],
                      [3.933, 0],
                      [2.4, -1.066],
                      [1.666, -2.266],
                      [0.533, -3.733],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    o: [
                      [0, 0],
                      [0, -4.533],
                      [2.033, -2.4],
                      [2.266, 0],
                      [1.366, 1.1],
                      [0.6, 2.067],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -4],
                      [-1.4, -3.033],
                      [-2.7, -1.733],
                      [-2.867, 0],
                      [-2.4, 1.067],
                      [-1.667, 2.267],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    v: [
                      [19.8, 0],
                      [19.8, -30.2],
                      [22.85, -40.6],
                      [31, -44.2],
                      [36.45, -42.55],
                      [39.4, -37.8],
                      [40.3, -30.2],
                      [40.3, 0],
                      [53.1, 0],
                      [53.1, -34.3],
                      [51, -44.85],
                      [44.85, -52],
                      [34.9, -54.6],
                      [27, -53],
                      [20.9, -48],
                      [17.6, -39],
                      [19.1, -38.4],
                      [18.6, -53.4],
                      [7, -53.4],
                      [7, 0]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'n',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              }
            ],
            nm: 'n',
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }
        ]
      },
      fFamily: 'Geist'
    },
    {
      ch: 'd',
      size: 128,
      style: 'SemiBold',
      w: 61.1,
      data: {
        shapes: [
          {
            ty: 'gr',
            it: [
              {
                ind: 0,
                ty: 'sh',
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.934, 1.6],
                      [-1.467, 2.867],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [2.833, 1.534],
                      [3.733, 0],
                      [3.333, -2.266],
                      [1.8, -4.2],
                      [0, -5.666],
                      [-1.8, -4.2],
                      [-3.3, -2.266],
                      [-4.534, 0]
                    ],
                    o: [
                      [2.933, -1.6],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.467, -2.8],
                      [-2.834, -1.533],
                      [-4.467, 0],
                      [-3.334, 2.267],
                      [-1.8, 4.2],
                      [0, 5.667],
                      [1.8, 4.2],
                      [3.3, 2.266],
                      [3.733, 0]
                    ],
                    v: [
                      [36, -1.2],
                      [42.6, -7.9],
                      [42.9, 0],
                      [55.1, 0],
                      [55.1, -71],
                      [42.3, -71],
                      [42.3, -45.8],
                      [35.85, -52.3],
                      [26, -54.6],
                      [14.3, -51.2],
                      [6.6, -41.5],
                      [3.9, -26.7],
                      [6.6, -11.9],
                      [14.25, -2.2],
                      [26, 1.2]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'd',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              },
              {
                ind: 1,
                ty: 'sh',
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [2.3, 3.167],
                      [0, 5.334],
                      [-2.3, 3.1],
                      [-3.867, 0],
                      [-1.834, -1.333],
                      [-0.967, -2.6],
                      [0, -3.8],
                      [0.966, -2.633],
                      [1.833, -1.333],
                      [2.666, 0]
                    ],
                    o: [
                      [-2.3, -3.166],
                      [0, -5.466],
                      [2.3, -3.1],
                      [2.666, 0],
                      [1.833, 1.334],
                      [0.966, 2.6],
                      [0, 3.734],
                      [-0.967, 2.634],
                      [-1.834, 1.334],
                      [-3.867, 0]
                    ],
                    v: [
                      [20.65, -13.95],
                      [17.2, -26.7],
                      [20.65, -39.55],
                      [29.9, -44.2],
                      [36.65, -42.2],
                      [40.85, -36.3],
                      [42.3, -26.7],
                      [40.85, -17.15],
                      [36.65, -11.2],
                      [29.9, -9.2]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: 'd',
                mn: 'ADBE Vector Shape - Group',
                hd: false
              }
            ],
            nm: 'd',
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: 'ADBE Vector Group',
            hd: false
          }
        ]
      },
      fFamily: 'Geist'
    }
  ]
}
